<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit Contact</h2>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>Contact Information</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-md-6">
        <app-input-component
          [label]="'First Name *'"
          [type]="'text'"
          [placeholder]="'Enter first name'"
          [(value)]="first_name"
        />
      </div>
      <div class="col-md-6">
        <app-input-component
          [label]="'Last Name *'"
          [type]="'text'"
          [placeholder]="'Enter last name'"
          [(value)]="last_name"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-md-6">
        <app-input-component
          [label]="'Email'"
          [type]="'email'"
          [placeholder]="'Enter email address'"
          [(value)]="email"
        />
      </div>
      <div class="col-md-6">
        <app-input-component
          [label]="'Phone'"
          [type]="'tel'"
          [placeholder]="'Enter phone number'"
          [(value)]="phone"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <label class="form-label required">Role</label>
        <app-selectorini
          [placeholder]="'Select a role'"
          [options]="roles"
          [disabled]="loadingRoles"
          [valueKey]="'role_id'"
          [displayKey]="'role_name'"
          [(value)]="role_id"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="'Update Contact'"
          [iconClass]="'fa fa-save'"
          [disabled]="!first_name || !last_name || role_id == null"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
